export { default as createOmitTypenameLink } from "./createOmitTypenameLink";
